import React, { useEffect } from "react";
import Head from "next/head";
import { useIntl } from "react-intl";
import Layout from "components/Layout";
import LayoutAuth from "components/Layout/Auth";
import Register from "components/Pages/Register";
import { getOrigin, redirectBackUrl } from "utils/method";
import getStaticProps_default from "utils/getStaticProps_default";
import { useRouter } from "next/router";
import Seo from "components/Seo";

const PagePath = "/register";

export default function PageRegister({ locale, TDK }) {
  const router = useRouter();
  const title = useIntl().formatMessage({ id: "register.title" });

  const onAuthError = () => {
    redirectBackUrl(router);
  };

  // 添加数据统计
  useEffect(() => {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML =
      "(function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function(){a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};a.queue=[];var s='script';r=t.createElement(s);r.async=!0;r.src=n;var u=t.getElementsByTagName(s)[0];u.parentNode.insertBefore(r,u);})(window,document,'https://sc-static.net/scevent.min.js');snaptr('init', 'b0724586-a27d-4ef5-a09c-ef349ae6264e', {'user_email': '__INSERT_USER_EMAIL__'});snaptr('track', 'PAGE_VIEW')";
    document.getElementsByTagName("head")[0].appendChild(script);
  }, []);

  return (
    <>
      <Seo tdk={TDK} resolvedUrl={PagePath} locale={locale} />

      <Layout>
        <LayoutAuth needLogin={false} onAuthError={onAuthError}>
          <Register />
        </LayoutAuth>
      </Layout>
    </>
  );
}

export const getStaticProps = (context) =>
  getStaticProps_default(context, { PagePath });
